import { render } from "./opp-confirm-modal.vue?vue&type=template&id=073b94a1&scoped=true"
import script from "./opp-confirm-modal.vue?vue&type=script&lang=js"
export * from "./opp-confirm-modal.vue?vue&type=script&lang=js"

import "./opp-confirm-modal.vue?vue&type=style&index=0&id=073b94a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073b94a1"]])

export default __exports__